import { useEffect, useState } from "react";

type QueryParams = Record<string, string>;

/**
 * 获取 query 参数。
 * @param key 不传时返回所有参数对象，传时返回指定参数值。
 */
export const useQueryParams = (key?: string): string | QueryParams | null => {
	const getParams = (): QueryParams => {
		const searchParams = new URLSearchParams(window.location.search);
		const result: QueryParams = {};
		for (const [k, v] of searchParams.entries()) {
			result[k] = v;
		}
		return result;
	};

	const [params, setParams] = useState<QueryParams>(getParams());

	useEffect(() => {
		const update = () => setParams(getParams());

		// popstate 监听后退/前进
		window.addEventListener("popstate", update);

		// 拦截 pushState 和 replaceState
		const wrapHistoryMethod = (method: "pushState" | "replaceState") => {
			const original = history[method];
			history[method] = function (...args) {
				const result = original.apply(this, args);
				update();
				return result;
			};
			return () => {
				history[method] = original;
			};
		};

		const undoPush = wrapHistoryMethod("pushState");
		const undoReplace = wrapHistoryMethod("replaceState");

		return () => {
			window.removeEventListener("popstate", update);
			undoPush();
			undoReplace();
		};
	}, []);

	if (typeof key === "string") {
		return params[key] ?? null;
	}

	return params;
};
